export const TEACHINGS = 'teachings';
